export function fade(el, { duration = 300, remove = true } = {}) {
  if (el.fadeInProgress) return
  el.fadeInProgress = true

  const oldTransition = el.style.transition
  const oldOpacity = el.style.opacity

  el.style.transition = `opacity ${duration}ms`
  el.style.opacity = '0'

  setTimeout(() => {
    if (remove) {
      el.remove()
    } else {
      el.style.transition = oldTransition
      el.style.opacity = oldOpacity
      el.fadeInProgress = false
    }
  }, duration)
}
